import { combineReducers } from 'redux';
import { reducer as reduxForm } from 'redux-form';

import activeConsent from './Pages/Consents/duck';
import activeForm from './Pages/Forms/duck';
import introduction from './Pages/Introduction/duck';
import review from './Pages/Review/duck';

export default combineReducers({
    form: reduxForm,
    introduction,
    activeConsent,
    activeForm,
    review
});
